import React, { useEffect, useState } from "react";
import { useAnalytics } from "use-analytics";
import { Helmet } from "react-helmet";
import {
  Foyer,
  FoyerFooter,
  FoyerTabs,
  PreviewWatermark,
  Theater,
} from "components";
import { useGetEvent } from "hooks";
import { useLocation } from "react-router-dom";
import { api } from "utils";

const useQuery = () => new URLSearchParams(useLocation().search);

export default ({ match }) => {
  const [tab, setTab] = useState("about");
  const [refresh, setRefresh] = useState(new Date());
  const [showPreview, setShowPreview] = useState(true);
  const [theaterModal, setTheaterModal] = useState(null);
  const [theaterCtaSenario, setTheaterCtaSenario] = useState(null);
  const { theaterData, foyerData, footerData } = useGetEvent({
    url: match.params.url,
    orderSlug: match.params.slug,
    subscriberSlug: useQuery().get("subscriberID"),
    refresh: refresh,
  });
  const { page } = useAnalytics();

  useEffect(() => {
    page();
  }, [page]);

  useEffect(() => {
    if (theaterData.active) {
      setShowPreview(false);
    } else if (theaterData.activated) {
      setShowPreview(false);
    } else if (new Date(theaterData.eventStart) < new Date("02/01/2023")) {
      setShowPreview(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theaterData.backgroundImage, theaterData.active, theaterData.activated]);

  const loaded = theaterData.active !== undefined;
  const slug =
    typeof window !== "undefined"
      ? window.location.pathname.split("/").pop()
      : "";

  return (
    <>
      <Helmet key={new Date()} title={theaterData.title}>
        <meta property="og:type" content="article" />
        <meta property="og:updated_time" content={new Date().getTime()} />
        <meta
          property="og:image"
          content={`${api}/v1/pages/${slug}/background-image?${new Date().getTime()}`}
        />
        <meta
          property="og:url"
          content={`https://showandtell.film/watch/${theaterData.featureUrl}`}
        />
      </Helmet>
      {loaded && showPreview && <PreviewWatermark />}

      <Theater
        {...theaterData}
        orderSlug={match.params.slug}
        subscriberSlug={useQuery().get("subscriberID")}
        setRefresh={setRefresh}
        loading={theaterData.eventId}
        externalModal={theaterModal}
        setExternalModal={setTheaterModal}
        externalTheaterCtaSenario={theaterCtaSenario}
        setExternalTheaterCtaSenario={setTheaterCtaSenario}
      >
        <FoyerTabs
          tab={tab}
          setTab={setTab}
          interactiveQa={foyerData.interactiveQa}
          {...(foyerData?.products?.length > 0 && {
            capability: foyerData?.capability,
          })}
          enableLive={foyerData.aboutSettings.enableLive}
        />
      </Theater>

      <Foyer
        {...foyerData}
        tab={tab}
        contactEmail={
          footerData.filmTeamEmail
            ? footerData.filmTeamEmail
            : "hello@showandtell.film"
        }
        setTheaterModal={setTheaterModal}
        setTheaterCtaSenario={setTheaterCtaSenario}
        gateStatus={theaterData.gateStatus}
      />

      <FoyerFooter />
    </>
  );
};
